export interface VendorPincodeActionTypes {
  type: VendorPincodeActions;
  payload?: any;
}

export enum VendorPincodeActions {
  GET_VENDOR_PINCODE_LIST = "GET_VENDOR_PINCODE_LIST",
  SET_VENDOR_PINCODE_LIST = "SET_VENDOR_PINCODE_LIST",
  SET_VENDOR_PINCODE_LIST_PAGE_COUNT = "SET_VENDOR_PINCODE_LIST_PAGE_COUNT",
}
